export { default as FavoriteButton } from './component';
